const challan_style = `
html, body, div, span, applet, object, iframe, h1, h2, h3, h4, h5, h6, p, blockquote, pre, a, abbr, acronym, address, big, cite, code, del, dfn, em, img, ins, kbd, q, s, samp, small, strike, strong, sub, sup, tt, var, b, u, i, center, dl, dt, dd, ol, ul, li, fieldset, form, label, legend, table, caption, tbody, tfoot, thead, tr, th, td, article, aside, canvas, details, embed, figure, figcaption, footer, header, hgroup, menu, nav, output, ruby, section, summary, time, mark, audio, video {
	margin: 0;
	padding: 0;
	border: 0;
	font-size: 100%;
	/*font: inherit;*/
	vertical-align: baseline;
}
img,
object,
embed {max-width: 100%;}
/* HTML5 display-role reset for older browsers */
article, aside, details, figcaption, figure, footer, header, hgroup, menu, nav, section {
	display: block;
}
ol, ul {
	list-style: none;
}
blockquote, q {
	quotes: none;
}
blockquote:before, blockquote:after, q:before, q:after {
	content: '';
	content: none;
}
table {
	border-collapse: collapse;
	border-spacing: 0;
}
.clear {
	clear: both;
}
.clear {
	clear: both;
}
body {
	font: 14px "istok_regular";
	/*overflow-y: scroll;*/
}
#header {
	/*height: 137px;*/
	width: 100%;
}
.hold {
	margin-top: 0px;
	margin-right: auto;
	margin-bottom: 0px;
	margin-left: auto;
	max-width: 82%;
}

.container .content {
	display: none;
}
#content {
	margin: 0px auto 50px;
	width: 1100px;
}
#content #side {
	width: 308px;
	min-height: 698px;
	border: 1px solid #cbcbcb;
	-moz-border-radius: 5px;
	-webkit-border-radius: 5px;
	border-radius: 5px;

	float: left;
}

#content #main {
	width: 748px;
	min-height: 698px;
	border: 1px solid #cbcbcb;
	-moz-border-radius: 5px;
	-webkit-border-radius: 5px;
	border-radius: 5px;
	float: right;

}


/* print CSS Only */
@media print{

	.hide-on-print {
		display: none;
	}

	.show-on-print {
		display: block;
	}
}

body {
	padding: 0px!important;
	background-color: var(--body-background-color)!important;
}

/* Fixed Footer */

body {
	display: flex;
	flex-direction: column;
	height: 100vh;
}

nav {
	flex-grow: 0;
	flex-shrink: 0;
}

`;

export default challan_style;
